export default __webpack_public_path__ + "static/media/wallet_connect.5cd49efd.svg";